import request from '@/config/axios'

export interface ScenicAiConfigVO {
  name: string
  avatar: string
  welcome: string
  questions: string[]
  modelId?: number
  systemPrompt: string
  enabled: boolean
}

export interface ScenicAiChatLogVO {
  userId: number
  userName: string
  question: string
  answer: string
  createTime: string
}

export const ScenicAiConfigApi = {
  getConfig: () => request.get<ScenicAiConfigVO>({ url: '/scenic/ai-config/get' }),
  saveConfig: (data: ScenicAiConfigVO) => request.post({ url: '/scenic/ai-config/save', data }),
  getChatLogPage: (params: { pageNo: number; pageSize: number }) =>
    request.get<{ list: ScenicAiChatLogVO[]; total: number }>({
      url: '/scenic/ai-config/logs',
      params
    })
}
